import { FS, fsTypeS3 } from "./fs";
import { FsDir } from "./fsentry";
import { apiFetch, mkURL, throwIfFetchFailed, xhrPut } from "./http";
import { throwIf } from "./util";

import type { HttpProgress } from "./http";
import type { S3Config } from "./fs";
import type { Writable } from "svelte/store";

class FileSystemS3 extends FS {
  constructor(s3Config: S3Config) {
    super(s3Config);
  }

  get s3Config(): S3Config {
    return this.config as S3Config;
  }

  async readDir(
    dirPath: string,
    force: boolean,
    progress: Writable<any>
  ): Promise<FsDir> {
    throwIf(dirPath == "", `empty dirName`);
    return this.loadDir(dirPath, force, progress, async () => {
      let entries = await s3GetFiles(this.s3Config, dirPath);
      return FsDir.fromWire(dirPath, entries);
    });
  }

  async getPublicURL(path: string): Promise<string> {
    console.log(`FSS3.getPublicURL: path=${path}`);

    // TODO: maybe cache the links?
    let c = this.s3Config;
    let url = mkAuthURL(c, `/api/s3/getpublicurl`, "path", path);
    let response = await apiFetch(url);
    throwIfFetchFailed(response);
    let js = await response.json();
    url = js.url;
    console.log("FSS3.getPublicURL: url:", url);
    url = mkURL(`https://workers.filerion.com/api/fetch`, "url", url);
    console.log("FSS3.getPublicURL: url proxied by fetch:", url);
    return url;
  }

  async uploadFile(path: string, file: Blob, httpProgress: HttpProgress) {
    console.log(`s3.uploadFile: ${path}`);
    path = s3SanitizePath(path);
    let c = this.s3Config;
    let url = mkAuthURL(c, `/api/s3/upload`, "path", path);
    await xhrPut(url, file, httpProgress);
  }

  async rename(path: string, newPath: string) {
    console.log(`s3.rename: path=${path}, newPath=${newPath}`);
    throwIf(path == newPath, "path must be != newPath");
    let c = this.s3Config;
    let url = mkAuthURL(c, `/api/s3/rename`, "path", path, "newPath", newPath);
    let response = await apiFetch(url);
    throwIfFetchFailed(response);
  }

  async createDirectory(path: string) {
    console.log(`s3.createDirectory: path=${path}`);
    let c = this.s3Config;
    let url = mkAuthURL(c, `/api/s3/createdirectory`, "path", path);
    let response = await apiFetch(url);
    throwIfFetchFailed(response);
  }

  async deleteFile(path: string) {
    path = s3SanitizePath(path);
    let c = this.s3Config;
    let url = mkAuthURL(c, `/api/s3/deletefile`, "path", path);
    console.log(`s3.deleteFile: path: ${path}, uri: ${url}`);
    let rsp = await apiFetch(url);
    await throwIfFetchFailed(rsp);
  }
}

function mkAuthURL(opts: S3Config, url: string, ...args: string[]): string {
  let params = [
    "secret",
    opts.secret,
    "access",
    opts.access,
    "bucket",
    opts.bucket,
    "endpoint",
    opts.endpoint,
  ];
  params.push(...args);
  return mkURL(url, ...params);
}

export function s3SanitizePath(s: string | undefined | null): string {
  s = s || "";
  if (s.startsWith("/")) {
    return s.substring(1);
  }
  return s;
}

export function s3SanitizeDir(s: string | undefined | null): string {
  s = s3SanitizePath(s);
  if (s != "" && !s.endsWith("/")) {
    return (s += "/");
  }
  return s;
}

export async function testS3Connection(s3Config: S3Config): Promise<Response> {
  let url = mkAuthURL(s3Config, `/api/s3/test`);
  console.log("testS3:", url);
  return await apiFetch(url);
}

async function s3GetFiles(c: S3Config, dir: string): Promise<any[][]> {
  dir = s3SanitizeDir(dir);
  let url = mkAuthURL(c, `/api/s3/list`, "dir", dir);
  console.log(`s3.getFiles: dirName: '${dir}'`);
  let rsp = await apiFetch(url);
  await throwIfFetchFailed(rsp);
  let entriesMeta = await rsp.json();
  return entriesMeta;
}

export function makeFileSystemS3(s3Config: S3Config): FileSystemS3 {
  return new FileSystemS3(s3Config);
}
